import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { useChallenge } from '../../../hooks';
import { GeogroupAvatar } from '../../geogroup-avatar';
import { medals } from '../medals';
function SitesLeaderboardItem({
  blurred,
  item,
  prevItemRank,
  challengeType,
  onClick
}) {
  const {
    getProgressValueWithUnit
  } = useChallenge();
  const medal = item && medals[item.rank - 1] || null;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    onClick: onClick,
    paddingX: 2,
    paddingY: 1,
    sx: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      ...(blurred && {
        filter: 'blur(0.25rem)'
      }),
      ...(onClick && {
        cursor: 'pointer',
        '&:hover': {
          bgcolor: '#f5f5f5'
        }
      })
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexShrink: 0,
    height: 24,
    justifyContent: "center",
    width: 30
  }, !item ? /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 24
  }) : item.rank === prevItemRank ? /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, "-") : medal ? /*#__PURE__*/React.createElement("img", {
    src: medal.icon,
    width: 24
  }) : /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, Math.max(item.rank, item.leaderboardIndex))), /*#__PURE__*/React.createElement(GeogroupAvatar, {
    geogroup: item ? {
      title: item.title,
      photo: item.photo
    } : undefined,
    size: 48
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, item ? item.title : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 80
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "right",
    variant: "body2"
  }, item ? getProgressValueWithUnit(challengeType || 'bttf', item.progressValue) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  }))));
}
export default SitesLeaderboardItem;